module.exports = __webpack_public_path__ + "static/img/boss_fleetstrategy.fefa2995.png";